import { FC } from "react"
import { SafetiesDetail } from "../../../module/safeties/containers/detail"

export const SafetiesDetailPage: FC = () => <SafetiesDetail />
